import React from 'react';
import {BrowserRouter,Route,Switch} from 'react-router-dom';
import login from './pages/login';
import cadastro from './pages/cadastro'
import {AuthProvider} from './auth/AuthContext';
import {DirectionscontextProvider} from './componentes/directionscontext';
import {RotaPrivada} from './auth/RotaPrivada';
import {resetPassword} from './pages/resetPassword';
import PageInit from './pages/PageInit';
import Agendar from './pages/Agendar';
import Consultar from './pages/Consultar';
import Viagem from './pages/Viagem';
import Motoristas from './pages/Motoristas';
import Usuarios from './pages/Usuarios';
import Veiculos from './pages/Veiculos';
import Aprovaviagem from './pages/Aprovaviagem';
import Parametronucleo from './pages/Parametronucleo';
import Parametrosupervisor from './pages/Parametrosupervisor';
import Relatorios from './pages/Relatorios';
import Relatoriomotoristas from './pages/Relatoriomotoristas';
import Relatoriodeferidas from './pages/Relatoriodeferidas';
import Relatorioanalise from './pages/Relatorioanalise';
import Relatorioveiculos from './pages/Relatorioveiculos';
import Relatoriofaturamento from './pages/Relatoriofaturamento';
import Relatoriosupervisor from './pages/Relatoriossupervisor';
import Cadastrarveiculo from './pages/Cadastrarveiculo';
import Consultaraprovada from './pages/Consultaraprovada';
import Consultarandamento from './pages/Consultarandamento';
import ConsultarCanceladas from './pages/ConsultarCanceladas';
import ConsultarRealizadas from './pages/ConsultarRealizadas';
import consultarAgendaMotorista from './pages/consultaAgendaMotorista';
import consultarMotoristaTransito from './pages/consultaMotoristaTransito';
import consultarencerradas from './pages/consultaEncerradas';
import minhasconcluido from './pages/minhasconcluido';
import minhastransito from './pages/minhastransito';
import filausuarios from './pages/filausuarios';
import filasupervisao from './pages/filasupervisao';
import filacentrosunidades from './pages/filacentrosunidades';
import minhasanalise from './pages/minhasanalise';
import recados from './pages/recados';
import testmap from './testmap/app';



function App() {
  return(
    <AuthProvider>
      <DirectionscontextProvider>

    <BrowserRouter>
      <Switch>
        <Route exact path="/"  component={login} />
        <Route exact path="/login" component={login} />
        <Route exact path="/cadastro" component={cadastro} />
        <Route exact path="/resetPassword" component={resetPassword}/>
        <RotaPrivada path="/PageInit" exact={true} component={PageInit} />
        <RotaPrivada path="/Agendar" exact={true} component={Agendar} />
        <RotaPrivada path="/Consultar" exact={true} component={Consultar} />
        <RotaPrivada path="/Motoristas" exact={true} component={Motoristas} />
        <RotaPrivada path="/Aprovaviagem" exact={true} component={Aprovaviagem} />
        <RotaPrivada path="/Parametronucleo" exact={true} component={Parametronucleo} />
        <RotaPrivada path="/Parametrosupervisor" exact={true} component={Parametrosupervisor} />
        <RotaPrivada path="/Relatorios" exact={true} component={Relatorios} />
        <RotaPrivada path="/Relatoriomotoristas" exact={true} component={Relatoriomotoristas} />
        <RotaPrivada path="/Relatoriodeferidas" exact={true} component={Relatoriodeferidas} />
        <RotaPrivada path="/Relatorioanalise" exact={true} component={Relatorioanalise} />
        <RotaPrivada path="/Relatorioveiculos" exact={true} component={Relatorioveiculos} />
        <RotaPrivada path="/Relatoriofaturamento" exact={true} component={Relatoriofaturamento} />
        <RotaPrivada path="/Relatoriosupervisor" exact={true} component={Relatoriosupervisor} />
        <RotaPrivada path="/Usuarios" exact={true} component={Usuarios} />
        <RotaPrivada path="/Veiculos" exact={true} component={Veiculos} />
        <RotaPrivada path="/Viagem" exact={true} component={Viagem} />
        <RotaPrivada path="/Cadastrarveiculo" exact={true} component={Cadastrarveiculo} />
        <RotaPrivada path="/Consultaraprovada" exact={true} component={Consultaraprovada} />
        <RotaPrivada path="/Consultarandamento" exact={true} component={Consultarandamento} />
        <RotaPrivada path="/ConsultarCanceladas" exact={true} component={ConsultarCanceladas} />
        <RotaPrivada path="/ConsultarRealizadas" exact={true} component={ConsultarRealizadas} />
        <RotaPrivada path="/consultarAgendaMotorista" exact={true} component={consultarAgendaMotorista} />
        <RotaPrivada path="/consultarMotoristaTransito" exact={true} component={consultarMotoristaTransito} />
        <RotaPrivada path="/consultarencerradas" exact={true} component={consultarencerradas} />
        <RotaPrivada path="/minhasconcluido" exact={true} component={minhasconcluido} />
        <RotaPrivada path="/minhastransito" exact={true} component={minhastransito} />
        <RotaPrivada path="/minhasanalise" exact={true} component={minhasanalise} />
        <RotaPrivada path="/filausuarios" exact={true} component={filausuarios} />
        <RotaPrivada path="/filasupervisao" exact={true} component={filasupervisao} />
        <RotaPrivada path="/filacentrosunidades" exact={true} component={filacentrosunidades} />
        <RotaPrivada path="/recados" exact={true} component={recados} />
        <RotaPrivada path="/testmap" exact={true} component={testmap} />



       
        <Route component={()=>(<div>Página 404</div>)}/>
      </Switch>
    </BrowserRouter>
    </DirectionscontextProvider>
    </AuthProvider>
  );
}

export default App;
